var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"z-index":"9999","show":_vm.showDialog},on:{"click":function($event){_vm.isClickClose ? (_vm.showDialog = false) : ''}}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{staticClass:"block",attrs:{"size":"50px","text-size":"16px","color":"#886DF3","text-color":"#666","vertical":""}},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }